import { __spreadArrays } from "tslib";
import { ErrorHandler, Provider } from '@angular/core';
import { SentryErrorHandler } from './core/services/sentry-error-handler';
import { RouterStateSerializer } from '@ngrx/router-store';
import { environment } from '../environments/environment';
import { PortalToastComponent } from './core/components/portal-toast/portal-toast.component';
import { CustomRouterStateSerializer } from './shared/utils';
// initialState for router reducer
var initialRouterState = {
    state: {
        section: 'Dashboard',
        url: '/',
        params: {},
        queryParams: {}
    },
    navigationId: 0
};
var initialState = {
    router: initialRouterState
};
// Toast options
var toastOptions = {
    closeButton: true,
    timeout: 5000,
    positionClass: 'toast-bottom-left',
    maxOpened: 3,
    autoDismiss: true,
    toastClass: 'toast custom-toast',
    preventDuplicates: true,
    toastComponent: PortalToastComponent
};
var ɵ0 = window;
var providers = __spreadArrays([
    {
        provide: ErrorHandler,
        useClass: SentryErrorHandler
    },
    {
        provide: 'Window',
        useValue: ɵ0
    }
], (environment.environment !== 'local'
    ? [
        {
            provide: RouterStateSerializer,
            useClass: CustomRouterStateSerializer
        }
    ]
    : [
        {
            provide: RouterStateSerializer,
            useClass: CustomRouterStateSerializer
        }
    ]));
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0 };
